import { render, staticRenderFns } from "./certificateTicket.vue?vue&type=template&id=f05e482c&scoped=true&"
import script from "./certificateTicket.vue?vue&type=script&lang=js&"
export * from "./certificateTicket.vue?vue&type=script&lang=js&"
import style0 from "./certificateTicket.vue?vue&type=style&index=0&id=f05e482c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05e482c",
  null
  
)

export default component.exports